export default "__VITE_ASSET__BbXJxDeL__"